// Varios pasos comparten nombre entre fases (Adorno, Corte, Pespunte, Montado...).
// Cuando un nombre es ambiguo dentro del modelo, lo mostramos con su fase: "Adorno (Muestra)".
export const ambiguosDeModelo = (pasos) => {
  const c = {};
  (pasos || []).forEach((p) => {
    c[p.nombre] = (c[p.nombre] || 0) + 1;
  });
  return new Set(Object.keys(c).filter((n) => c[n] > 1));
};

export const etiquetaPaso = (step, pasosOrSet) => {
  if (!step) return "";
  const amb = pasosOrSet instanceof Set ? pasosOrSet : ambiguosDeModelo(pasosOrSet);
  return amb.has(step.nombre) ? `${step.nombre} (${step.fase})` : step.nombre;
};
